import 'moment/dist/locale/en-gb';
import 'moment/dist/locale/nl';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './globalDeclarations';
import './yup.i18n';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import moment from 'moment';
import { QueryParamProvider } from 'use-query-params';

import UserAgentWarning from '$components/shared/components/UserAgentWarning';
import MaintenanceGuard from '$components/shared/MaintenanceGuard';
import RoutesGuard from '$components/shared/RoutesGuard';
import { GoogleMapsProvider } from '$utils/GoogleMapsProvider';

import App from './app';
import i18n from './i18n';
import * as serviceWorker from './serviceWorker';
import theme from './theme';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './index.css';

const nonLibraryPages = ['notificationbase'];

moment().locale('en-gb');
window.moment = moment;

const currentRoute = window.location.pathname;
let loadLibraries = true;

for (const page of nonLibraryPages) {
  if (currentRoute.search(page) !== -1) {
    loadLibraries = false;
  }
}

if (loadLibraries) {
  window.google?.charts?.load('current', {
    packages: ['corechart', 'bar', 'geochart'],
    mapsApiKey: `${process.env.VITE_GOOGLE_API}`,
  });
}

const appHeight = () => {
  document.documentElement.style.setProperty(
    '--app-height',
    `${window.innerHeight}px`
  );
};
window.addEventListener('resize', appHeight);
appHeight();

// Outer myRotra container!
createRoot(document.querySelector('#root')!).render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n} defaultNS="translation">
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline enableColorScheme />
          <UserAgentWarning />
          <Router>
            <MaintenanceGuard>
              <GoogleMapsProvider>
                <QueryParamProvider ReactRouterRoute={Route}>
                  <RoutesGuard>
                    <HelmetProvider>
                      <App />
                    </HelmetProvider>
                  </RoutesGuard>
                </QueryParamProvider>
              </GoogleMapsProvider>
            </MaintenanceGuard>
          </Router>
        </ThemeProvider>
      </StyledEngineProvider>
    </I18nextProvider>
  </React.StrictMode>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
